/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

// Load global components
import Loading from 'components/Loading/Loading';

// Load local components
import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import ReassignLeadForm from './ReassignLeadForm/ReassignLeadForm';
import ReassignLeadSuccess from './ReassignLeadSuccess/ReassignLeadSuccess';
import ReassignLeadError from './ReassignLeadError/ReassignLeadError';
import Form from '../../../../../forms/_.extend';

// Load styles
import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
  projectDetailsStore: Object,
  userStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'userStore', 'projectDetailsStore')
@observer
export default class ReassignLead extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, projectDetailsStore }: TypeProps = this.props;

    const project: Object = this.props.project;

    const fields: Array<Object> = [
      {
        name: 'reassignProjectTo',
        label: t('general:actions.reassign_project_lead_to'),
        title: 'Reassign Project Lead To',
        fields: [
          {
            name: 'assigneeId',
            label: t('general:labels.assignee'),
            rules: 'required|string',
            placeholder: t('general:placeholders.first_last_name'),
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        if (!(project && project.trading_account)) {
          projectDetailsStore.clearDetails();
          projectDetailsStore.loadProjectDetails(project.id);
        }
      },
      onSuccess(data: Object) {
        const { assigneeId }: Object = data.values().reassignProjectTo;

        actionDrawerStore.reassignProject(project.id, {
          project_lead_id: assigneeId,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Reassign Project',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { project, actionDrawerStore, userStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.reassign_project_lead')} />
          <ReassignLeadError project={project} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.reassign_project_lead')} />
          <ReassignLeadSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.reassign_project_lead')} />
        <ReassignLeadForm
          project={project}
          user={userStore.getActiveUserFromLocal()}
          form={this.createForm()}
        />
      </div>
    );
  }
}
